const defaultTestimonials = [
  { name: 'Lily R.', message: 'Excellent care, friendly staff, and quick appointment scheduling.' },
  { name: 'Ahmed K.', message: 'The doctors are very knowledgeable and took the time to explain everything.' },
  { name: 'Tanya S.', message: 'Clean environment and professional service, highly recommended.' }
]

export default defaultTestimonials
